import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ProfileRepository from '../../repositories/ProfileRepository';
import ProfileDataRepository from '../../../data/repositories/ProfileDataRepository';

export default function* getProfileMastersData(action: any): any {
  try {
    yield put({ type: Types.GET_PROFILE_MASTERS_DATA_REQUEST });

    const profileMastersDataRepository: ProfileRepository =
      new ProfileDataRepository();
    const profileMastersDataResponse = yield call(
      profileMastersDataRepository.getProfileMastersData,
      action.profileType
    );

    yield put({
      type: Types.GET_PROFILE_MASTERS_DATA_SUCCESS,
      data: profileMastersDataResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_PROFILE_MASTERS_DATA_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del estudiante.'
    });
  }
}
